export default __webpack_public_path__ + "static/media/store.01d286d2.svg";